'use strict';

function isGroupSuspended(data) {
    return (data && data.renewalDateInStartDateWindow);
}

function getSupportTexti18nPostfix(data, postfixId) {
    if(isGroupSuspended(data)) {
        return 'startDateSupportTextSuspended' + postfixId;
    } else {
        return 'startDateSupportText' + postfixId;
    }
}

function getSupportTextStyleClass(data) {
    var style;
    if(isGroupSuspended(data)) {
        style = 'policy-start-date-support-text--pumpkin';
    }
    return style;
}

module.exports.getSupportTexti18nPostfix = getSupportTexti18nPostfix;
module.exports.getSupportTextStyleClass = getSupportTextStyleClass;



//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/utils/renewalSuspended.js
// module id = WMth
// module chunks = 2